import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top
 * whenever the route (pathname) changes.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!hash) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Use smooth scrolling for better UX
      });
    } else {
      // If there is a hash, scroll to that element with a slight delay
      // to ensure the element is fully rendered
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          
          // Special handling for calculator
          if (id === 'calculator') {
            // Create and dispatch a custom event
            const event = new CustomEvent('calculatorNavigated');
            document.dispatchEvent(event);
          }
        }
      }, 100);
    }
  }, [pathname, hash]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;